import React from "react";
import ProductImages from "./ProductImages";
import PotencyCircles from "./PotencyCircles";
import PriceDisplay from "./ProductPrice";
import styled from "@emotion/styled";
import AddToFavorites from "./AddToFavorites";

const ProductCard = ({
  data,
  selectedIndex,
  handleImageClick,
  priceInfo,
  productId,
  collectionPath,
}) => {
  if (!data) return null;
  return (
    <ProductCardContainer>
      <ProductImagesContainer>
        <ProductImages
          images={data.images}
          handleImageClick={handleImageClick}
          selectedIndex={selectedIndex}
        />
      </ProductImagesContainer>
      <ProductCardRight>
        <p>{data.productId}</p>
        <AddToFavorites
          productId={data?.product_id}
          collectionPath={collectionPath}
        />
        <PriceSection>
          <PriceDisplay priceInfo={priceInfo} priceTheme="listing" zoom={1.6} />
        </PriceSection>
        <ProductDetailsSection>
          <PotencyWrapper>
            <PotencyCircles
              containerStyles={{ justifyContent: "flex-start" }}
              value={data?.potency_value}
              text={"Potency"}
            />
          </PotencyWrapper>
          <div style={{ height: 10 }} />
          <KeyIngredientsSection>
            Key Ingredients:{" "}
            {data.key_ingredients || <span style={{ color: "gray" }}>--</span>}
          </KeyIngredientsSection>
          <div style={{ height: 10 }} />
          {!Number.isNaN(data.tac) && data.tac && (
            <TACSection>TAC: {data.tac}%</TACSection>
          )}
        </ProductDetailsSection>
      </ProductCardRight>
    </ProductCardContainer>
  );
};

export default ProductCard;

const ProductCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (min-width: 755px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const ProductImagesContainer = styled.div`
  align-self: center;
`;

const ProductCardRight = styled.div`
  @media (min-width: 755px) {
    align-self: flex-start;
    padding-bottom: 40px;
  }
`;

const PriceSection = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 0px 10px 20px 10px;
  @media (min-width: 755px) {
    justify-content: flex-end;
  }
`;

const ProductDetailsSection = styled.div`
  padding: 0 10px;
  font-size: 14px;
  @media (min-width: 755px) {
    font-size: 1.1rem;
  }
`;

const PotencyWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  @media (min-width: 755px) {
    justify-content: flex-end;
  }
`;

const KeyIngredientsSection = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  font-weight: 300;
  color: black;
  margin-top: 5px;
  @media (min-width: 755px) {
    text-align: right;
    font-size: 1.15rem;
  }
`;

const TACSection = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 0.9rem;
  font-weight: 300;
  color: black;
  margin-top: 5px;
  @media (min-width: 755px) {
    text-align: right;
    font-size: 1.15rem;
  }
`;

